export default import.meta.ROLLDOWN_FILE_URL_ZdbXYw6QRX2rvRlorMJdGQ